var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sectionTitleStyle === 1)?_c('div',{staticClass:"section-title",class:_vm.checkTextAlign},[_c('h4',{staticClass:"subtitle"},[_c('span',{staticClass:"theme-gradient",domProps:{"innerHTML":_vm._s(_vm.subtitle)}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }